const moneyFormatter = new Intl.NumberFormat('es-CL', {
    minimumFractionDigits: 0
})

const formatearDinero=monto=>{
    return moneyFormatter.format(monto)
}

export default formatearDinero